module.exports = __webpack_public_path__ + "static/media/HelpAI3_preview.e56a3aa5.jpg";